import React, { useEffect, useState } from 'react';
import {
  CButton,
  CCard,
  CCardHeader,
  CCol,
  CFormInput,
  CFormLabel,
  CHeader,
  CRow,
  CForm,
  CModal
} from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { getAll } from 'src/services/CashAndBanks';
import { DataGrid } from '@mui/x-data-grid';
import formatter from 'src/reusables/formatter';
import Select from 'react-select';
import { transfer, passwordValidation } from 'src/services/CashAndBanks';
import { Toaster } from 'src/components/Toaster';
import ls from 'local-storage';
import md5 from 'md5';


function CashAndBanks() {
  const [dataRows, setDataRows] = useState([]);
  const [dataColumns, setDataColumns] = useState([]);
  const [modalTransferOpen, setModalTransferOpen] = useState(false);
  const [cabOptionsMaster, setCabOptionsMaster] = useState([]);
  const [cabOptionsFrom, setCabOptionsFrom] = useState([]);
  const [cabOptionsTo, setCabOptionsTo] = useState([]);
  const [cabOptionsSelectedFrom, setCabOptionsSelectedFrom] = useState({});
  const [cabOptionsSelectedTo, setCabOptionsSelectedTo] = useState({});
  const [amount, setAmount] = useState(0);
  const [modalPasswordOpen, setModalPasswordOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [isBtnDisabled, setIsBtnDisabled] = useState(true);

  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState("")
  const [color, setColor] = useState("")
  
  const navigate = useNavigate();

  async function fetchMainData() {
    const res = await getAll();
    const rows =
      res.cashAndBanks &&
      res.cashAndBanks.map((item, i) => {
        return {
          no: i + 1,
          id: item.id,
          name: item.name,
          code: item.code,
          bankName: item.bankName,
          description: item.description,
          balance: formatter('currency', item?.balance ?? 0)
        };
      });

    setDataRows(rows);

    const columns = [
      { field: 'no', headerName: 'No', width:'150' },
      { field: 'name', headerName: 'Name', width:'150' },
      { field: 'code', headerName: 'Code', width:'150' },
      { field: 'bankName', headerName: 'Bank Name', width:'150' },
      { field: 'description', headerName: 'Description', width:'150' },
      { field: 'balance', headerName: 'Balance', width:'150' }
    ];

    setDataColumns(columns);
    
    let cabOptionsRaw = rows.map((item, i) => {
      return {
        ...item,
        label: `${item.bankName} - ${item.name}`,
        value: item.id
      }
    })

    setCabOptionsMaster(cabOptionsRaw)
    setCabOptionsFrom(cabOptionsRaw)
    setCabOptionsTo(cabOptionsRaw)
  }

  useEffect(() => {
    fetchMainData();
  }, []);

  function handleRowClick(params) {
    navigate('/cab-actions', { state: params.row });
  }

  function handleSelected(e, action){
    let prevState = [cabOptionsSelectedFrom, cabOptionsSelectedTo]

    if(action === "from"){
      setCabOptionsSelectedFrom(e)
      prevState =[e]
      if(e.value === cabOptionsSelectedTo.value){
        setCabOptionsSelectedTo({})
      }
    } else {
      if(e.value === cabOptionsSelectedFrom.value){
        setCabOptionsSelectedFrom({})
      }
      setCabOptionsSelectedTo(e)
      prevState =[e]
    }

    let newOptions = cabOptionsMaster.filter((item) => {
      return !prevState.some((prev) =>  prev.value === item.value)
    })
    
    if(action === "from"){
      setCabOptionsFrom(newOptions)
    } else {
      setCabOptionsTo(newOptions)
    }
  }

  function closeModalTransfer(){
    setModalTransferOpen(false)
    setAmount(0)
    setCabOptionsFrom(cabOptionsMaster)
    setCabOptionsTo(cabOptionsMaster)
    setCabOptionsSelectedFrom({})
    setCabOptionsSelectedTo({})
  }

  async function submitTransfer(){
    let passed = {
      from: cabOptionsSelectedFrom.id,
      to: cabOptionsSelectedTo.id,
      amount
    }

    const response = await transfer(passed)

    if(response.data.success === 1){
      navigate(0)
    }
  }

  // function closePasswordModal(){
  //   setPassword('')
  //   setModalPasswordOpen(false)
  // }

  async function validatePassword(){
    let data = {
      email: ls.get("userDetail").email,
      password: md5(password)
    }

    const validation = await passwordValidation(data)

    if(parseInt(validation.data.success) === 1){
      submitTransfer()
    } else {
      setMessage('Wrong Password')
      setColor('red')
      setOpen(true)
    }
  }

  return (
    <div style={{ color: 'black' }}>
      <Toaster
        open={open}
        message={message}
        setOpen={setOpen}
        ahd={1500}
        color={color ?? "red"}
      />
      <CModal
        style={{borderRadius:"12px"}}
        visible={modalPasswordOpen}
        onClose={
          () => {
            closeModalTransfer()
            setModalPasswordOpen(false)
            setPassword('')
          }
        }
      >
        <div style={{
          margin:"2vh"
        }}>
          <CHeader style={{fontWeight: "bold"}}>
            Password
          </CHeader>
          <CForm>
            <CFormInput type="password" value={password} onChange={(e)=>{setPassword(e.target.value)}} />
          </CForm>
          <CButton
            style={{
              color: 'black',
              backgroundColor: 'white',
              marginTop:"1vh"
            }}
            onClick={() => {
              closeModalTransfer()
              setModalPasswordOpen(false)
              setPassword('')
            }}
          >
            Cancel
          </CButton>
          &emsp;
          <CButton
            color="success"
            style={{
              color: 'white',
              marginTop:"1vh"
            }}
            onClick={() => validatePassword()}
          >
            Continue
          </CButton>
        </div>
      </CModal>
      <CModal 
        visible={modalTransferOpen}
        style={{borderRadius:"12px"}}
      >
        <div style={{
          margin:"2vh"
        }}>
          <CHeader style={{fontWeight: "bold"}}>
            Transfer Fund
          </CHeader>
          <CForm>
            <CFormLabel>From:</CFormLabel>
            <Select
              options={cabOptionsFrom}
              value={cabOptionsSelectedFrom}
              onChange={(e) => handleSelected(e, "from")}
            />
            <CFormLabel>To:</CFormLabel>
            <Select
              options={cabOptionsTo}
              value={cabOptionsSelectedTo}
              onChange={(e) => handleSelected(e, "to")}
            />
            <CFormLabel>Amount:</CFormLabel>
            <CFormInput 
              type="number"
              onWheel={(e) => e.target.blur()}
              min="0"
              max="999999999999"
              value={amount}
              onChange={(e) => {
                let value = e.target.value
                let data = value.replace(/^0+/, '')
                  if(e.target.value <= 999999999999 && e.target.value > 0 ){
                    setAmount(data)
                    setIsBtnDisabled(false)
                  } else if(e.target.value < 0){
                    setAmount(0)
                    setIsBtnDisabled(true)
                  } else if(isNaN(data)){
                    setIsBtnDisabled(true)
                  } else if(e.target.value >= 999999999999){
                    setAmount(999999999999)
                    setIsBtnDisabled(false)
                  } else if(parseInt(e.target.value) === 0){
                    setAmount(0)
                    setIsBtnDisabled(true)
                  } else {
                    setAmount(0)
                    setIsBtnDisabled(true)
                  }
              }}
            />
          </CForm>
          <CButton
            style={{
              color: 'black',
              backgroundColor: 'white',
              marginTop:"1vh"
            }}
            onClick={() => {
              closeModalTransfer()
            }}
          >
            Cancel
          </CButton>
          &emsp;
          <CButton
            color="success"
            style={{
              color: 'white',
              marginTop:"1vh"
            }}
            disabled={isBtnDisabled}
            onClick={() => {
              setModalTransferOpen(false)
              setModalPasswordOpen(true)}}
          >
            Save
          </CButton>
        </div>
      </CModal>
      {/* <CHeader style={{ fontSize: '30px', marginTop: '3vh', padding: '1vh 2vw' }}>
        Cash And Banks
      </CHeader> */}
      <CCard>
        <CCardHeader>Cash And Banks</CCardHeader>
        <div style={{ margin: '16px' }}>
          <CRow className="mb-3">
            <CCol xs={7} lg={7}></CCol>
            <CCol xs={5} lg={5} style={{ textAlign: 'right' }}>
              <CButton
                style={{ borderColor: 'primary' }}
                onClick={() => {
                  setModalTransferOpen(true);
                }}
              >
                Transfer
              </CButton>
              &nbsp;
              <CButton
                style={{ borderColor: 'primary' }}
                onClick={() => {
                  navigate('/cab-actions');
                }}
              >
                Create
              </CButton>
              {/* &nbsp;
              <CButton
                style={{ backgroundColor: 'white', color: 'black' }}
                onClick={() => {
                  navigate('/cab-actions');
                }}
              >
                Download
              </CButton> */}
            </CCol>
          </CRow>
          <DataGrid
            rows={dataRows}
            columns={dataColumns}
            onRowClick={handleRowClick}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 }
              }
            }}
            pageSizeOptions={[5, 10, 20, 25]}
            style={{ textAlign: 'center' }}
          />
        </div>
      </CCard>
    </div>
  );
}

export default CashAndBanks;
